import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import {
  Grid,
  Paper,
  TextField,
  InputLabel,
  FormControl,
  Button,
  MenuItem,
  useMediaQuery,
  Select,
  CircularProgress,
} from "@mui/material";
import TitleBar from "../TitleBar";
import { attendanceMenu, FixedEmployeeTitle } from "../TitleList";
import "./EmployeeAttendance.css";
import axios, { all } from "axios";
import { getCurrentDate } from "../../Utils/Dateutils";
import { useDispatch, useSelector } from "react-redux";
import { fetchLocationData } from "../../Store/PHPSlice/Transport";
import { selectlocationdata } from "../Selectors/Master/ItemSelectors";

const EmployeeAttendance = () => {
  const isDesktop = useMediaQuery("(min-width:768px)");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const userdata = JSON.parse(localStorage.getItem("user"));
  const [location, setLocation] = useState("");
  const [employee, setEmployee] = useState(null);
  const [curdt, setCurdt] = useState(getCurrentDate());
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState({
    totDays: '0',
    presentDays: '0',
    leaveDays: '0'
  });

  const [ledgerList, setLedgerList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [allEmployee, setAllEmployee] = useState([]);

  const [multiEmployee, setMultiEmployee] = useState(false);
  const [punchingData, setPunchingData] = useState([]);

  const dispatch = useDispatch();
  const locationdata = useSelector(selectlocationdata);

  useEffect(() => {
    dispatch(fetchLocationData());
  }, []);

  const fetchFixedEmpReg = async (id) => {
    try {
      const res = await axios.get(`${baseUrl}?apicall=getFixedEmployeeReg&locId=${id}`);

      const data = res?.data?.data2;
      // console.log(data);
      setLedgerList(data);
    } catch (error) {
      console.error(error);
      setLedgerList([]);
    }
  };

  const fetchPuchingDataApi = async (fdt, tdt, pid, locId) => {
    try {
      const res = await axios.get(`${baseUrl}?apicall=getEmployeePunchingData&fromdt=${fdt}&todt=${tdt}&punchId=${pid}&locId=${locId}`);
      // console.log(res.data);

      if (res.data.status === "success") {
        const result = res.data?.data;
        return result;
      } else {
        const msg = Array.isArray(res.data.msg) ? res.data.msg.join("\n") : res.data.msg;
        alert(msg);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPuchingDataApiAllEmp = async (fdt, tdt, locId) => {
    try {
      const res = await axios.get(`${baseUrl}?apicall=getAllEmployeePunchingDataLocationWise&fromdt=${fdt}&todt=${tdt}&locId=${locId}`);
      // console.log(res.data);

      if (res.data.status === "success") {
        const result = res.data?.data;
        return result;
      } else {
        const msg = Array.isArray(res.data.msg) ? res.data.msg.join("\n") : res.data.msg;
        alert(msg);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 🔁 Generate Dates
  const generateRows = async () => {
    if (!employee || !fromDate || !toDate) return;

    // ✅ MUST await
    const apiDataRaw = await fetchPuchingDataApi(
      fromDate,
      toDate,
      employee?.punchId,
      location
    );

    // ✅ Normalize to array (if backend returned object)
    const apiData = Array.isArray(apiDataRaw)
      ? apiDataRaw
      : Object.values(apiDataRaw || {});

    // Fast lookup by date
    const punchMap = new Map(apiData.map((p) => [p.date, p])); // p.date must exist

    const rows = [];
    let d = new Date(fromDate);
    const end = new Date(toDate);

    const toYMD = (dateObj) => dateObj.toLocaleDateString("en-CA"); // local YYYY-MM-DD

    while (d <= end) {
      const dateStr = toYMD(d);
      const punch = punchMap.get(dateStr);

      rows.push({
        date: dateStr,
        in1: punch?.in1 || "00:00",
        out1: punch?.out1 || "00:00",
        in2: punch?.in2 || "00:00",
        out2: punch?.out2 || "00:00",
        in3: punch?.in3 || "00:00",
        out3: punch?.out3 || "00:00",
        in4: punch?.in4 || "00:00",
        out4: punch?.out4 || "00:00",
        hours: punch?.totworkhrs || 0,
        extraHr: punch?.extrahrs || 0,
        scheduleType: punch?.scheduleType || "Hr",
      });

      d.setDate(d.getDate() + 1);
    }

    const toMinutes = (time) => {
      if (!time || typeof time !== "string") return '00:00';
      const [h, m] = time?.split(":").map(Number);
      return h * 60 + m;
    };

    const presentDays = rows.filter(r => toMinutes(r.hours) > 0).length;

    const totalDays = rows.length;

    const leaveDays = totalDays - presentDays;

    setRows(rows);
    setFormData(prev => ({
      ...prev,
      totDays: totalDays,
      presentDays: presentDays,
      leaveDays: leaveDays
    }));
  };


  const generateRowsForEmployees = async () => {
    if (!ledgerList || ledgerList.length === 0 || !fromDate || !toDate) return;

    const apiDataRaw = await fetchPuchingDataApiAllEmp(fromDate,
      toDate,
      location);
    const updatedEmployees = ledgerList.map((emp) => {
      const rows = [];
      let d = new Date(fromDate);
      const end = new Date(toDate);

      while (d <= end) {
        rows.push({
          date: d.toISOString().split("T")[0], // YYYY-MM-DD
          in1: "",
          out1: "",
          in2: "",
          out2: "",
          in3: "",
          out3: "",
          in4: "",
          out4: "",
          hours: 0,
          extraHr: 0,
          scheduleType: "Hr",
        });
        d.setDate(d.getDate() + 1);
      }

      return {
        ...emp,
        rows,
      };
    });
    // console.log(updatedEmployees);

    setAllEmployee(updatedEmployees); // assumes you have employees in state
  };

  function getTimeDifferenceMidnight(t1, t2) {
    const isValidTime = (t) => {
      if (!t || typeof t !== "string") return false;

      const [h, m] = t.split(":").map(Number);
      return (
        Number.isFinite(h) &&
        Number.isFinite(m) &&
        h >= 0 &&
        h < 24 &&
        m >= 0 &&
        m < 60
      );
    };

    // If either time is invalid or missing → return 0
    if (!isValidTime(t1) || !isValidTime(t2)) {
      return 0; // or return null if you prefer
    }

    const [h1, m1] = t1.split(":").map(Number);
    const [h2, m2] = t2.split(":").map(Number);

    let minutes1 = h1 * 60 + m1;
    let minutes2 = h2 * 60 + m2;

    // Handle midnight crossover
    if (minutes2 < minutes1) {
      minutes2 += 24 * 60;
    }

    return minutes2 - minutes1;
  }

  function getTimeDiffHM(t1, t2) {
    const diff = getTimeDifferenceMidnight(t1, t2);
    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;
    return `${hours}:${minutes}`;
  }

  function sumTimeHM(times) {
    // convert each H.MM to minutes and sum
    const totalMinutes = times.reduce((sum, val) => {
      const safeNumber = (val) => (Number.isFinite(val) ? val : 0);
      val = safeNumber(val);
      return sum + val;
    }, 0);

    // convert back to H.MM
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  }

  function workHoursToMinutes(value) {
    if (value == null) return 0;

    // Case 1: string format "H:MM"
    if (typeof value === "string" && value.includes(":")) {
      const [h, m] = value.split(":").map(Number);
      if (!Number.isFinite(h) || !Number.isFinite(m)) return 0;
      return h * 60 + m;
    }

    // Case 2: number or numeric string like 8.02
    const num = Number(value);
    if (!Number.isFinite(num)) return 0;

    const hours = Math.floor(num);
    const minutes = Math.round((num - hours) * 100); // .02 → 2 min, .20 → 20 min

    if (minutes >= 60) return 0; // invalid time

    return hours * 60 + minutes;
  }

  // ⌛ Update Time
  const updateTime = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    const times = [
      getTimeDifferenceMidnight(updated[index].in1, updated[index].out1),
      getTimeDifferenceMidnight(updated[index].in2, updated[index].out2),
      getTimeDifferenceMidnight(updated[index].in3, updated[index].out3),
      getTimeDifferenceMidnight(updated[index].in4, updated[index].out4),
    ];
    const totalMinutes = times.reduce((sum, val) => {
      const safeNumber = (val) => (Number.isFinite(val) ? val : 0);
      val = safeNumber(val);
      return sum + val;
    }, 0);

    const total = sumTimeHM(times);

    const per_day_workhrs = workHoursToMinutes(employee.workHours);
    // console.log(per_day_workhrs,'total', totalMinutes);
    if (totalMinutes > per_day_workhrs) {
      let extra_hrs = totalMinutes - parseFloat(per_day_workhrs);
      const ex_hours = Math.floor(extra_hrs / 60);
      const ex_minutes = extra_hrs % 60;
      updated[index].extraHr =
        `${ex_hours}:${ex_minutes.toString().padStart(2, "0")}`;
    } else {
      updated[index].extraHr = '00:00';
    }

    const min_half = 3 * 60; // 180
    const max_half = 4 * 60; // 240

    const min_full = 6 * 60;
    const max_full = 8 * 60;

    if (totalMinutes >= min_half && totalMinutes <= max_half) {
      updated[index].scheduleType = "Half Day";
    }
    if (totalMinutes >= min_full) {
      updated[index].scheduleType = "Full Day";
    }

    // rebuild time
    updated[index].hours = total;



    const toMinutes = (time) => {
      if (!time || typeof time !== "string") return '00:00';
      const [h, m] = time.split(":").map(Number);
      return h * 60 + m;
    };

    const presentDays = updated.filter(r => toMinutes(r.hours) > 0).length;
    // console.log(updated);
    const totalDays = updated.length;

    const leaveDays = totalDays - presentDays;

    setFormData(prev => ({
      ...prev,
      totDays: totalDays,
      presentDays: presentDays,
      leaveDays: leaveDays
    }));
    setRows(updated);

  };

  const updateAllTime = (empIndex, rowIndex, field, value) => {
    const updated = [...allEmployee];

    const row = { ...updated[empIndex].rows[rowIndex] };
    row[field] = value;

    const safeNumber = (val) => (Number.isFinite(val) ? val : 0);

    const h1 = safeNumber(getTimeDiffHM(row.in1, row.out1));
    const h2 = safeNumber(getTimeDiffHM(row.in2, row.out2));
    const h3 = safeNumber(getTimeDiffHM(row.in3, row.out3));
    const h4 = safeNumber(getTimeDiffHM(row.in4, row.out4));

    const total = h1 + h2 + h3 + h4;

    // split hours & minutes
    let hours = Math.floor(total);
    let minutes = Math.round((total - hours) * 100);

    // normalize minutes
    hours += Math.floor(minutes / 60);
    minutes = minutes % 60;

    const str_tot = parseFloat(
      `${hours}:${minutes.toString().padStart(2, "0")}`,
    );

    const perDayWorkHrs = Number(updated[empIndex].workHours || 0);

    row.hours = str_tot;
    row.extraHr = str_tot > perDayWorkHrs ? str_tot - perDayWorkHrs : 0;

    updated[empIndex].rows[rowIndex] = row;
    setAllEmployee(updated);
  };

  // 📊 Summary
  // const totalDays = rows.length;
  // const presentDays = rows.filter((r) => r.hours > 0).length;
  // const leaveDays = totalDays - presentDays;

  let totalMinutes = rows.reduce((sum, r) => {
    const hoursStr = String(r.hours);
    // console.log(hoursStr);
    const [h, m] = hoursStr.split(':');

    const hrs = parseInt(h, 10) || 0;
    const mins = parseInt(m, 10) || 0;

    return sum + (hrs * 60) + mins;
  }, 0);



  // normalize
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // final value like 6.30
  const normalizedTotal = parseFloat(
    `${hours}.${minutes.toString().padStart(2, "0")}`,
  );

  const payable = normalizedTotal * (parseFloat(employee?.perHour) || 0);
  let extraTotalMinutes = rows.reduce((sum, r) => {
    const extraHrStr = String(r.extraHr);

    const [h, m] = extraHrStr.split(':');

    const hrs = parseInt(h, 10) || 0;
    const mins = parseInt(m, 10) || 0;

    return sum + (hrs * 60) + mins;
  }, 0);

  // normalize
  const hours2 = Math.floor(extraTotalMinutes / 60);
  const minutes2 = extraTotalMinutes % 60;

  const normalizedExtraTotal = parseFloat(
    `${hours2}.${minutes2.toString().padStart(2, "0")}`,
  );

  const payload = () => {
    const data = {
      entrydt: curdt,
      fdt: fromDate,
      tdt: toDate,
      rows: rows,
      empId: employee?.empId,
      punchId: employee?.punchId,
      employee: employee,
      totdays: formData.totDays,
      present_days: formData.presentDays,
      leave_days: formData.leaveDays,
      totwork_hr: normalizedTotal?.toFixed(2),
      payamt: Math.round(payable),
      perHr_pay: employee.perHour,
      totextra_hrs: normalizedExtraTotal,
      userId: userdata?.ID,
    };
    return data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postObj = payload();
    console.log('payload', postObj);
    setLoading(true);
    try {
      const res = await axios.post(
        `${baseUrl}?apicall=insertEmployeeAttendance`,
        postObj,
      );
      // console.log(res.data);
      const data = res?.data;
      if (data.status === "pending") {
        // console.log(data.msg);
        alert(data.msg);
      } else if (data.status === "success") {
        alert(data.msg);
        window.location.reload();
      } else {
        alert(data.msg[0] || data.msg);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // const employee_data = ledgerList?.map(e => ({
  //   label: e.ledger,
  //   value: e.empId,
  // }));

  const locationOptions = [
    ...locationdata?.data.map((e) => ({
      label: e.locNm,
      value: e.ID
    })),
  ];
  const employeeOptions = [
    { label: "All", value: "all" },
    ...ledgerList?.map((e) => ({
      label: e.ledger,
      value: e.empId,
    })),
  ];



  // const handleEmployeeChange = (e) => {
  //   const { name, value } = e.target;
  //   if (value === "all") {
  //     const data = { empId: 'all' };
  //     setEmployee(data);
  //     setMultiEmployee(true);
  //   } else {
  //     const empobj = ledgerList?.find(emp => emp.empId === value);
  //     setEmployee(empobj);
  //     setMultiEmployee(false);
  //   }
  // };

  const handleEmployeeChange = (selectedOption) => {
    if (!selectedOption) return;

    if (selectedOption.value === "all") {
      setEmployee({ empId: "all" });
      setMultiEmployee(true);
      // setLocation(""); // clear location for "all"
    } else {
      const empobj = ledgerList?.find(
        (emp) => emp.empId === selectedOption.value,
      );
      setEmployee(empobj);
      setMultiEmployee(false);
      // setLocation(empobj?.location || ""); // auto-set location
    }
    setRows([]);
    setFormData(prev => ({
      ...prev,
      totDays: 0,
      presentDays: 0,
      leaveDays: 0
    }));
  };

  const handleLocationChange = (selectedOption) => {
    if (!selectedOption) return;

    if (selectedOption.value) {
      fetchFixedEmpReg(selectedOption.value);

      setLocation(selectedOption?.value || "")
    }

  }

  // console.log(allEmployee)
  return (
    <>
      <TitleBar data={attendanceMenu} />

      <div style={{ margin: "1%" }}>
        {/* ================= FILTER ================= */}
        <Paper style={{ padding: "1vh", marginBottom: "12px" }}>
          <Grid container spacing={1}>
            {[
              {
                label: "Entry Date",
                type: "date",
                value: curdt,
                onChange: (e) => setCurdt(e.target.value),
              },
              {
                label: "Location",
                isLocation: true,
              },
              {
                label: "Employee",
                customComponent: true,
              },
              {
                label: "From Date",
                type: "date",
                value: fromDate,
                onChange: (e) => setFromDate(e.target.value),
              },
              {
                label: "To Date",
                type: "date",
                value: toDate,
                onChange: (e) => setToDate(e.target.value),
              },
            ].map((f, i) => (
              <Grid item xs={12} md={6} key={i}>
                <Grid container spacing={1} alignItems="center">
                  <Grid
                    item
                    style={isDesktop ? { width: "30%" } : { width: "100%" }}
                  >
                    <InputLabel>{f.label} :</InputLabel>
                  </Grid>
                  <Grid item xs>
                    <FormControl fullWidth>
                      {f.isLocation ? (
                        <ReactSelect
                          options={locationOptions}
                          value={
                            locationOptions.find(
                              (opt) => opt.value === location,
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            handleLocationChange(selectedOption)
                          }
                          isClearable
                          placeholder="Select Location"
                        />
                      ) : f.customComponent ? (
                        <ReactSelect
                          options={employeeOptions}
                          value={employeeOptions.find(
                            (opt) => opt.value === (employee?.empId || ""),
                          )}
                          onChange={handleEmployeeChange}
                          isClearable
                          placeholder="Select Employee"
                        />
                      ) : (
                        <TextField
                          type={f.type || "text"}
                          size="small"
                          value={f.value}
                          onChange={f.onChange}
                        />
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            ))}

            <Grid item xs={12} textAlign="center">
              <Button
                variant="contained"
                onClick={
                  employee?.empId === "all"
                    ? generateRowsForEmployees
                    : generateRows
                }
              >
                GET
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {/* ================= EMP INFO ================= */}
        {employee && multiEmployee !== true && (
          <Paper
            style={{
              padding: "8px",
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ marginRight: "20px" }}>
              Employee: <b>{employee?.ledger}</b>
            </div>

            <div style={{ marginRight: "20px" }}>
              Punching Id: <b>{employee?.punchId}</b>
            </div>

            <div style={{ marginRight: "20px" }}>
              Working Hours: <b>{employee?.workHours}</b>
            </div>
            <div style={{ marginRight: "20px" }}>
              Working Type: <b>{employee?.paymentType}</b>
            </div>
            <div>
              Amount: <b>{employee?.paymentAmount}</b>
            </div>
          </Paper>
        )}

        <>
          {/* ================= TABLE ================= */}
          {/* <Paper style={{ padding: "8px" }}>
          <Grid container className="table-row header">
            {[
              "Date",
              "In1",
              "Out1",
              "In2",
              "Out2",
              "In3",
              "Out3",
              "In4",
              "Out4",
              "Working Hrs",
              "Extra Hrs",
              "Schedule Type"
            ].map((h) => (
              <Grid item xs={1} key={h}>
                {h}
              </Grid> // Adjusted column width
            ))}
          </Grid>

          {rows?.map((r, i) => (
            <Grid container className="table-row data" key={i}>
              <Grid item xs={1}>
                {r.date}
              </Grid>

              {["in1", "out1", "in2", "out2", "in3", "out3", "in4", "out4"].map(
                (f) => (
                  <Grid item xs={1} key={f}>
                    <input
                      type="time"
                      lang="en-GB"
                      step="60"
                      value={r[f]}
                      onChange={(e) => updateTime(i, f, e.target.value)}
                    />
                  </Grid>
                )
              )}

              <Grid item xs={1}>
                {r.hours.toFixed(2)}
              </Grid>

              <Grid item xs={1}>
                {r.extraHr.toFixed(2)}
              </Grid>

              <Grid item xs={1.2}>
                <FormControl fullWidth size="small">
                  <Select
                    value={r.scheduleType}
                    onChange={(e) => {
                      const updatedRows = [...rows];
                      updatedRows[i].scheduleType = e.target.value;
                      setRows(updatedRows);
                    }}
                  >
                    <MenuItem value="Hr">Hr</MenuItem>
                    <MenuItem value="Leave Day">Leave Day</MenuItem>
                    <MenuItem value="Full Day">Full Day</MenuItem>
                    <MenuItem value="Half Day">Half Day</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
          ))}
        </Paper> */}
        </>

        {/* single Employee */}
        {multiEmployee !== true && (
          <Paper style={{ padding: "8px" }}>
            <table>
              <thead>
                {[
                  "Date",
                  "In1",
                  "Out1",
                  "In2",
                  "Out2",
                  "In3",
                  "Out3",
                  "In4",
                  "Out4",
                  "Working Hrs",
                  "Extra Hrs",
                  "Schedule Type",
                ].map((item) => (
                  <th>{item}</th>
                ))}

                {rows?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ whiteSpace: "nowrap" }}>{item.date}</td>

                    {[
                      "in1",
                      "out1",
                      "in2",
                      "out2",
                      "in3",
                      "out3",
                      "in4",
                      "out4",
                    ].map((f) => (
                      <td key={f}>
                        <input
                          type="time"
                          lang="en-GB"
                          step="60"
                          value={item[f]}
                          onChange={(e) => updateTime(index, f, e.target.value)}
                        />
                      </td>
                    ))}

                    <td>{item.hours}</td>
                    <td>{item.extraHr}</td>

                    <td>
                      <FormControl fullWidth size="small">
                        <Select
                          value={item.scheduleType}
                          onChange={(e) => {
                            const updatedRows = [...rows];
                            updatedRows[index].scheduleType = e.target.value;
                            setRows(updatedRows);
                          }}
                        >
                          <MenuItem value="Hr">Hr</MenuItem>
                          <MenuItem value="Leave Day">Leave Day</MenuItem>
                          <MenuItem value="Full Day">Full Day</MenuItem>
                          <MenuItem value="Half Day">Half Day</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                ))}
              </thead>
            </table>
          </Paper>
        )}

        {/* all employee */}
        <div>
          {multiEmployee === true && (
            <Paper style={{ padding: "8px" }}>
              <table style={{ display: 'flex', width: '100%', overflowX: 'auto' }}>
                <thead>
                  {[
                    "Employee",
                    "Punch Id",
                    "Date",
                    "In1",
                    "Out1",
                    "In2",
                    "Out2",
                    "In3",
                    "Out3",
                    "In4",
                    "Out4",
                    "Working Hrs",
                    "Extra Hrs",
                    "Schedule Type",
                  ].map((item) => (
                    <th>{item}</th>
                  ))}

                  {allEmployee?.map((emp, empIndex) =>
                    emp?.rows?.map((item, rowIndex) => (
                      <tr key={`${empIndex}-${rowIndex}`}>
                        <td>{emp.ledger}</td>
                        <td style={{ whiteSpace: "nowrap" }}>{emp.punchId}</td>

                        <td style={{ whiteSpace: "nowrap" }}>{item.date}</td>

                        {[
                          "in1",
                          "out1",
                          "in2",
                          "out2",
                          "in3",
                          "out3",
                          "in4",
                          "out4",
                        ].map((f) => (
                          <td key={f}>
                            <input
                              type="time"
                              lang="en-GB"
                              step="60"
                              value={item[f] || ""}
                              onChange={(e) =>
                                updateAllTime(
                                  empIndex,
                                  rowIndex,
                                  f,
                                  e.target.value,
                                )
                              }
                            />
                          </td>
                        ))}

                        <td>{Number(item.hours || 0).toFixed(2)}</td>
                        <td>{Number(item.extraHr || 0).toFixed(2)}</td>

                        <td>
                          <FormControl fullWidth size="small">
                            <Select
                              value={item.scheduleType || emp.work_type || ""}
                              onChange={(e) => {
                                const updated = [...allEmployee];
                                updated[empIndex].rows[rowIndex].scheduleType =
                                  e.target.value;
                                setAllEmployee(updated);
                              }}
                            >
                              <MenuItem value="Hr">Hr</MenuItem>
                              <MenuItem value="Leave Day">Leave Day</MenuItem>
                              <MenuItem value="Full Day">Full Day</MenuItem>
                              <MenuItem value="Half Day">Half Day</MenuItem>
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    )),
                  )}

                  {/* {rows?.map((item, index) => (
                <tr key={index}>
                  <td style={{ whiteSpace: 'nowrap' }}>{item.date}</td>


                  {["in1", "out1", "in2", "out2", "in3", "out3", "in4", "out4"].map(
                    (f) => (
                      <td key={f}>
                        <input
                          type="time"
                          lang="en-GB"
                          step="60"
                          value={item[f]}
                          onChange={(e) => updateTime(index, f, e.target.value)}
                        />
                      </td>
                    )
                  )}

                  <td>{item.hours.toFixed(2)}</td>
                  <td>{item.extraHr.toFixed(2)}</td>

                  <td>
                    <FormControl fullWidth size="small">
                      <Select
                        value={item.scheduleType}
                        onChange={(e) => {
                          const updatedRows = [...rows];
                          updatedRows[index].scheduleType = e.target.value;
                          setRows(updatedRows);
                        }}
                      >
                        <MenuItem value="Hr">Hr</MenuItem>
                        <MenuItem value="Leave Day">Leave Day</MenuItem>
                        <MenuItem value="Full Day">Full Day</MenuItem>
                        <MenuItem value="Half Day">Half Day</MenuItem>
                      </Select>
                    </FormControl>
                  </td>
                </tr>
              ))} */}
                </thead>
              </table>
            </Paper>
          )}

        </div>

        {/* ================= SUMMARY ================= */}
        {rows.length > 0 && multiEmployee !== true && (
          <Paper style={{ padding: "8px", marginTop: "10px" }}>
            <Grid container spacing={2} className="summary">
              <Grid item xs={4}>
                Total Days : {formData.totDays}
              </Grid>
              <Grid item xs={4}>
                Present : {formData.presentDays}
              </Grid>
              <Grid style={{ color: "red" }} item xs={4}>
                Leave : {formData.leaveDays}
              </Grid>
              <Grid item xs={4}>
                Per Hour Pay: {employee.perHour}
              </Grid>
              <Grid item xs={4}>
                Total Work Hours : {normalizedTotal.toFixed(2)}
              </Grid>
              <Grid item xs={4}>
                Total Extra Work Hours : {normalizedExtraTotal.toFixed(2)}
              </Grid>
              <Grid item xs={4}>
                Payable Amount : {Math.round(payable)}
              </Grid>
            </Grid>
          </Paper>
        )}

        <Grid item xs={12} textAlign="center" mt={2}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading === true}
          >
            {loading === true ? (
              <>
                <CircularProgress size="20px" /> wait...
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </Grid>
      </div>
    </>
  );
};

export default EmployeeAttendance;
